import React from 'react';
import axios from 'axios';

import { formatDate } from '../../Utils/GlobalUtils';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

const ComplaintsFinder = ({ caseId, access }) => {
    const [complaints, setComplaints] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/checking-for-complaints?caseId=${caseId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then(response => {
            setWarning('');
            setComplaints(response.data);
        })
        .catch(error => {
            setWarning(`Не удалось проверить наличие жалоб:  ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setLoading(false);
        })
    }, [caseId]);

    return (
        loading ? <Loading />
        : warning ? <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{warning}</a>
        : complaints.length > 0 &&
        <>
            <div className={styles.cardOfCaseLine}>
                <h2>Найдена жалоба:</h2>
                <a className={styles.complaintPanel}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="#0a349f" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>
                    <div className={styles.rightComplaintPanel}>
                        {complaints.map((complaint) => (
                            <div className={styles.complaint} key={complaint.id}>
                                <a>Номер жалобы: {complaint.number || 'Не указано'}</a>
                                <a>Заявитель: {complaint.applicant || 'Не указано'}</a>
                                <a>За кем закреплено: {complaint.worker_lastname ? (<>{complaint.worker_lastname} {complaint.worker_firstname} {complaint.worker_surname}</>) : 'Работник СОАУ не присвоен'}</a>
                                <a style={{textDecoration: 'underline'}} href={`mailto:${complaint.user_email}`}>{complaint.worker_email}</a>
                                <a>Арбитражный управляющий: {complaint.user_lastname ? (<>{complaint.user_lastname} {complaint.user_firstname} {complaint.user_surname}</>) : 'Арбитражный управляющий не назначен'}</a>
                                <a style={{textDecoration: 'underline'}} href={`mailto:${complaint.user_email}`}>{complaint.user_email || ''}</a>
                                <a>Дата поступления жалобы: {formatDate(complaint.date_start)}</a>
                                {access && 
                                    <>
                                        <span style={{marginTop: '10px'}}></span>
                                        <a className={styles.linkBtn} onClick={() => {window.open(`/case/${complaint.id}`, '_blank')}}>Перейти к карточке жалобы</a>
                                    </>
                                }
                            </div>
                        ))}
                    </div>
                </a>
            </div>
        </>
    )
}

export default ComplaintsFinder;